/**
 * Placeholder copy for /sitemap-submitted until remaining report-details
 * fields are available from APIs. Do not hardcode subscription Usage here —
 * Usage comes from the subscription dashboard APIs for authorized users only.
 */
const SITEMAP_SUBMITTED_PLACEHOLDERS = {
  productType: '—',
  delivery: 'Regular',
  reasonForChange:
    'More information was required. 5 structures were identified. User needs to identify which of these structures they want measured.',
};

export default SITEMAP_SUBMITTED_PLACEHOLDERS;
